<template>
	<div id="app" class="pc">
	    <Header></Header>
	    <keep-alive>
	        <transition name="fade">
	            <router-view />
	        </transition>
	    </keep-alive>
	    <Footer></Footer>
	</div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
    components: {
        Header,
        Footer,
    },
};
</script>

<style>
</style>
